// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__11Fx6","signatureButtonsRight":"ModalSign_signatureButtonsRight__2f2b6"};